/** @format */

import Messages from "./../library/Messages";

export default class Copy {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Copy();
		self.attachEvents();
	}

	static clipboardCopy(result) {
		const self = new Copy();

		self.clipboardCopy(result);
	}

	attachEvents() {
		const self = this;

		$(document).on("click", ".js-copy-to-clipboard", function (e) {
			e.preventDefault();

			self.clipboardCopy($(this).data("copy"));
		});
	}

	clipboardCopy(value) {
		const self = this;

		console.log(value);

		if (typeof ClipboardItem && navigator.clipboard.write) {
			// Safari + Chrome clipboard method
			var clipBlob = new Blob([value], {
				type: "text/plain",
			});

			const clipText = new ClipboardItem({
				["text/plain"]: clipBlob,
			});

			navigator.clipboard.write([clipText]).then(
				function () {
					Messages.success("Link copied");
				},
				function () {
					Messages.error("Error Occurred");
				}
			);
		} else {
			// For FF support
			navigator.clipboard.writeText(value).then(
				function () {
					Messages.success("Link copied");
				},
				function () {
					Messages.error("Error Occurred");
				}
			);
		}

		navigator.clipboard.writeText(value).then(
			function () {
				Messages.success("Link copied");
			},
			function () {
				Messages.error("Error Occurred");
			}
		);
	}
}
